import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'push-message';

const ClientService = {
  getPagedResult({
      page,limit,searchText,searchBy,type
  }) {
    return Http.get(`/${RESOURCE_NAME}?type=${type}&page=${page}&limit=${limit}&searchText=${searchText}&searchBy=${searchBy}&orders[id]=DESC`);
  },
}
export default ClientService;
